import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import Vconsole from "vconsole";
import { ENVIRONMENT } from "./config/config";

// if (["test", "pre"].includes(ENVIRONMENT)) {
  if (["local", "test", "pre"].includes(ENVIRONMENT)) {
  console.info("ENVIRONMENT", ENVIRONMENT);
  new Vconsole();
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<App />);
